import templateUrl from 'emun.salesrep/show-appointment-projections.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config';

class ShowAppointmentProjectionsController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
		let $ctrl = this;
		var context = $ctrl.context || 'rep';

		$ctrl.activityType = salesrepConfig.showroomActivityType || "Show Appointment";
		$ctrl.year = $ctrl.market.year; //new Date().getFullYear();
		$ctrl.numAppointmentsGoal = 0;
		$ctrl.dollarAmountGoal = 0;

		this.activities = {
			total: 0,
			count: 0
		};

		var repFilter = "";
		if (context !== 'executive') {
			var filterType = "SalesRep";
			if (context === 'manager') {
				filterType = 'ManagerId';
			}
			repFilter = "&" + filterType + "=" + $ctrl.rep.id;
		}

		if ($ctrl.market.projectionDollar > 0) {
			$ctrl.avgAppointment = $ctrl.market.projectionDollar;
		} else {
			this.weeklyAverageQuery = createAutoQuery({
				url: 'QueryWeeklyBookingAverageShow?count=weeknumber&sum=WeekAvg&WeekAvgLessThan=1000000&GroupBy=SalesRep&showcode=' + $ctrl.market.projectionShowCode + repFilter,
				pageSize: 1000,
				autoLoad: true,
				onLoaded: function (avgArgs) {
					var totalavg = 0;
					avgArgs.results.forEach(function (result) {
						totalavg += result.sumWeekAvg / result.countweeknumber;
					});
					$ctrl.avgAppointment = totalavg / avgArgs.total;
				}
			});
		}

		filterType = "SalesRep";
		repFilter = "";
		if (context !== 'executive') {
			if (context === 'ManagerId') {
				filterType = 'ManagerId';
			}
			repFilter = "&" + filterType + "=" + $ctrl.rep.id;
		}

		$ctrl.loadChartData = function (args) {
			$ctrl.chartLabels = ["Appointments"];
			$ctrl.chartSeries = ["Actual", "Goal"];
			$ctrl.chartData = [];
			$ctrl.chartData.push([$ctrl.activities.count]);
			$ctrl.chartData.push([$ctrl.numAppointmentsGoal]);
			$ctrl.chartLoaded = true;
		};

		filterType = "repId";
		repFilter = "";
		if (context !== 'executive') {
			if (context === 'manager') {
				filterType = 'ManagerId';
			}
			repFilter = "&" + filterType + "=" + $ctrl.rep.id;
		}

		this.weeklyAverageQuery = createAutoQuery({
			url: 'QueryActivityTypes?RequireShowCode=True',
			pageSize: 10,
			autoLoad: true,
			onLoaded: function (data) {
				if (data.results) {
					$ctrl.showTypes = Array.prototype.map.call(data.results, s => s.type).toString();
				}

				this.activitiesCount = createAutoQuery({
					url: 'QueryActivitiesJoin.json?showCode=' + $ctrl.market.showCode + "&typeIn=" + $ctrl.showTypes + repFilter + '&dateRange=YTD&Count=Id&GroupBy=username',
					autoLoad: true,
					pageSize: 1000,
					onLoaded: function (args) {
						args.results.forEach(function (total) {
							$ctrl.activities.count += total.Total;
						});
						$ctrl.showAppointmentGoals = createAutoQuery({
							url: 'QueryShowGoals.json?showCode=' + $ctrl.market.showCode + repFilter + '&year=' + $ctrl.year + '&activityType=' + $ctrl.activityType + '&Sum=NumActivities&GroupBy=ShowCode',
							autoLoad: true,
							pageSize: 1000,
							onLoaded: function (args) {
								args.results.forEach(function (total) {
									$ctrl.numAppointmentsGoal += total.sumNumActivities;
									//$ctrl.dollarAmountGoal += total.sumDollarAmount;
								});
								$ctrl.showDollarGoals = createAutoQuery({
									url: 'QueryShowGoals.json?showCode=' + $ctrl.market.showCode + repFilter + '&year=' + $ctrl.year + '&Sum=DollarAmount&GroupBy=ShowCode',
									autoLoad: true,
									pageSize: 1000,
									onLoaded: function (args) {
										args.results.forEach(function (total) {
											//$ctrl.numAppointmentsGoal += total.sumNumActivities;
											$ctrl.dollarAmountGoal += total.sumDollarAmount;
										});
										if ($ctrl.numAppointmentsGoal === 0) $ctrl.visible = false;
										$ctrl.loadChartData();
									}
								});
							}
						});
					}
				});
			}
		});

		var gfilterType = "SalesRepID";
		var gfilter = "";
		if (context !== 'executive') {
			if (context === 'manager') {
				gfilterType = 'ManagerId';
			}
			gfilter = gfilterType + "=" + $ctrl.rep.id;
		}

		$ctrl.colors = salesrepConfig.chartColors;
		this.chartOptions = {
			maintainAspectRatio: false,
			legend: {
				display: true,
				labels: {
					boxWidth: 5,
					fontSize: 10
				}
			},
			elements: {
				rectangle: {
					borderWidth: 1
				}
			},
			scales: {
				yAxes: [{
					display: true,
					ticks: {
						min: 0
						//callback: function (value, index, values) {
						//	return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
						//}
					}
				}]
			},
			tooltips: {
				enabled: true,
				//callbacks: {
				//	label: function (tooltipItem, data) {
				//		var label = data.datasets[tooltipItem.datasetIndex].label;
				//		var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
				//		return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				//	}
				//}
			}
		};


		//$ctrl.salesGoals = createAutoQuery({
		//    url: 'QueryRepMonthlyGoals.json?' + gfilter,
		//    autoLoad: true,
		//    onLoaded: function(args) {
		//        var thisMonth = moment().month();
		//        var nextMonth = moment().month() + 1;
		//        args.results.forEach(function(r) {
		//            var month = moment(r.month).month();
		//            if (month == thisMonth) {
		//                $ctrl.thisMonthActivities.goal = r.goal;
		//            }
		//            if (month == nextMonth) {
		//                $ctrl.nextMonthActivities.goal = r.goal;
		//            }
		//        });
		//    }
		//});
	}
}

let ShowAppointmentProjections = {
	bindings: {
		rep: '<',
		context: '@',
		showcode: '@',
		market: '<',
		visible: '='
	},
	controller: ShowAppointmentProjectionsController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}


export default ShowAppointmentProjections;